var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconFlask = function SvgIconFlask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 29 26",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_flask_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h29v26H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#icon_flask_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M12.42 2.21v5.78l-9.49 15.8h23.057l-9.49-15.8V2.21zm-2 0v5.22L.766 23.5q-.474.773-.174 1.5.283.688 1.064.79h25.605q.781-.102 1.064-.79.3-.727-.174-1.5L18.497 7.43V2.21h2.133a1.01 1.01 0 0 0 1-1 1 1 0 0 0-.3-.71.97.97 0 0 0-.7-.29H8.21a.99.99 0 0 0-1 1c0 .26.1.52.29.71.19.18.44.29.71.29z",
    className: "icon_flask_svg__outline"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#875DE2",
    d: "M16.322 10.709c.176 0 .339.093.43.244l6.546 10.999a.5.5 0 0 1-.429.756H5.962a.5.5 0 0 1-.429-.756l6.547-10.999a.5.5 0 0 1 .429-.244zm-.097 5.904a1.714 1.714 0 1 0-.001 3.429 1.714 1.714 0 0 0 .001-3.429m-3.524-2.524a1.143 1.143 0 1 0 0 2.287 1.143 1.143 0 0 0 0-2.287",
    className: "icon_flask_svg__fill"
  }))));
};
export default SvgIconFlask;